import * as moment from "moment";
import * as React from "react";
import Player from "source/app/domain/Player";
import { CICOCalories } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/CICO/Calories/CICOCalories";
import { useIntervalToRerender } from "source/app/services/Shared/Hooks/useIntervalToRerender";
import { CICOProtein } from "./Protein/CICOProtein";
import { CICOWeight } from "./Weight/CICOWeight";

export function CICOContainer() {
    useIntervalToRerender(60000);

    const startTime = moment().hour(Player.startingHour).minute(0).second(0);
    const currentTime = moment();
    const endTime = moment().hour(Player.endingHour).minute(0).second(0);

    const timeCompleteMinutes = currentTime.diff(startTime, "minutes");
    const totalTimeMinutes = endTime.diff(startTime, "minutes");

    const timeCompletePercent = Math.min(
        Math.floor((timeCompleteMinutes / totalTimeMinutes) * 100),
        100
    );

    return (
        <div
            style={{
                textAlign: "center",
                margin: "20px",
                borderRadius: "6px",
                background: "rgb(0 0 0 / 15%)",
                padding: "10px",
            }}
        >
            <div>Start time: {startTime.format(`LT`)}</div>
            <div>Current time: {currentTime.format(`LT`)} </div>
            <div>End time: {endTime.format(`LT`)}</div>
            <div>Time: {timeCompletePercent}%</div>
            <span style={{ display: `flex`, flexFlow: `row wrap` }}>
                <CICOCalories {...{ timeCompletePercent }} />
                <CICOProtein {...{ timeCompletePercent }} />
                <CICOWeight />
            </span>
        </div>
    );
}
